export const NORMALIZE_INITIAL_DATA_ACTION = '@app/utility/normalizeInitialData';

export const normalizeInitialDataAction = () => ({
	type: NORMALIZE_INITIAL_DATA_ACTION
});



// WEBPACK FOOTER //
// ./actions/UtilityActions.js